import { useElementSize } from '~/scripts/composables/useElementSize'
import { useTailwind } from '~/scripts/composables/useTailwind'
import { defineComponent } from '~/scripts/utils/alpine'

export default defineComponent(() => ({
  mobileMenuVisible: false,
  hasAnchors: false,
  init() {
    if (this.$refs.header) {
      useElementSize(this.$refs.header, ({ height }) => {
        this.$store.ui.headerHeight = height
      })
    }

    if (document.querySelector('.b-anchors')) {
      this.hasAnchors = true
    }

    this.$watch('mobileMenuVisible', (value) => {
      if (value) {
        this.$store.ui.lockScrollBy('mobile-menu')
        this.updateMenuOffsetTop(this.$refs.header)
      }
      else {
        this.$store.ui.unlockScrollBy('mobile-menu')
      }
    })

    // Reset menus (resize might a switch from mobile to desktop or vice versa)
    const { breakpoints } = useTailwind()
    const mediaQuery = window.matchMedia(`(width >= ${breakpoints.lg})`)
    mediaQuery.addEventListener('change', () => {
      this.mobileMenuVisible = false
    })
  },
  updateMenuOffsetTop(header: HTMLElement) {
    const { bottom } = header.getBoundingClientRect()
    this.$store.ui.menuOffsetTop = bottom
  },
}))
